import { useCallback } from 'react'
import { useApiQuery } from 'admin/lib/Api'

export function GetPageNames(accountId, projectId, connectionId) {
  const pageNames = useApiQuery(
    useCallback(
      async api => {
        const names = {}
        if (accountId && accountId !== 'new') {
          const [responseDataAccount, statusAccount, errorAccount] =
            await api.getAccount(accountId)
          if (errorAccount) {
            return [responseDataAccount, statusAccount, errorAccount]
          }
          names.accountName = responseDataAccount.name

          if (projectId && projectId !== 'new') {
            const [responseDataProject, statusProject, errorProject] =
              await api.getProject(accountId, projectId)
            if (errorProject) {
              return [responseDataProject, statusProject, errorProject]
            }
            names.projectName = responseDataProject.name

            if (connectionId && connectionId !== 'register') {
              const [
                responseDataConnection,
                statusConnection,
                errorConnection
              ] = await api.getConnection(accountId, projectId, connectionId)
              if (errorConnection) {
                return [
                  responseDataConnection,
                  statusConnection,
                  errorConnection
                ]
              }
              names.connectionName = responseDataConnection.name
            }
          }
        }
        return [names, null, null]
      },
      [accountId, connectionId, projectId]
    )
  )
  return pageNames
}
